module.exports = __webpack_public_path__ + "img/logo.ff5fa0cc.png";